// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bbt_a bhc_jx","ListItemIcon--empty":"bbt_b bhc_ff"};